import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { IdleService } from './services/idle.service';
import { Subscription, combineLatest } from 'rxjs';
import { AuthService } from './services/auth.service';
import { UserDeviceService } from './services/user-device.service';
import { LoginService } from './services/login.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'my-taskEasy';
  showHead: boolean = false;
  idleshow = false;
  display = false;
  hasToken = false;
   deviceInfo: any=[];

  private sub!: Subscription;
  constructor(private router: Router,private idleService: IdleService,private authService: AuthService,     private loginService:LoginService,
     public deviceService:UserDeviceService,    private ngxService: NgxUiLoaderService,
     
  ) {
    // on route change to '/login', set the variable showHead to false
    
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'].includes('/login') || event['url'] == '/' || event['url'].includes('/#/login') || event['url'].includes('/verify') || event['url'].includes('/password-expired') || event['url'].includes('/reset-password')) {
          this.showHead = false;
          localStorage.setItem('showHeader', 'false')
        } else {
          this.showHead = true;
          localStorage.setItem('showHeader', 'true')
        }
      }
    });
  }
ngOnInit(): void {

//    var token =localStorage.getItem('auth_token');
//    if(token!=null){
//  console.log(this.hasToken)
//  this.hasToken=true
//     this.idleService.idleState.subscribe(isIdle => {
//       this.display = isIdle && this.hasToken;
//     });
//    }
    // this.sub = combineLatest([this.idleService.idleState, this.authService.token$])
    //   .subscribe(([isIdle, token]) => {
    //     console.log(isIdle)
    //     console.log(token)
    //     this.display = isIdle && !!token;
    //   });
      this.deviceService.storeIP();
      this.deviceService.epicFunction();
      this.deviceService.shareDeviceDetails.subscribe(res=> {
        this.deviceInfo = res;
      })

        this.sub = combineLatest([this.idleService.idleState, this.authService.token$])
    .subscribe(([isIdle, token]) => {
       console.log(isIdle)
        // console.log(token)
      this.display = !!token && isIdle;
    });

}

  logOut() {
    this.ngxService.start();
    let taskId=localStorage.getItem('taskId');


    let req = {
      'userLogoutIp': this.deviceInfo.IP,
      'logoutBrowser': this.deviceInfo.deviceInfo.browser
    }
    console.log("last update time===",localStorage.getItem('currentDate'))
    this.loginService.logoutUser(req)
      .subscribe(res => {
        if (res['status']['statusMsg'] === 'Success') {
         
          localStorage.clear();
            this.authService.clearToken();
            this.authService.setToken(null)
             this.idleService.stopIdleDetection();

          if(taskId){
          localStorage.setItem('taskId',taskId);
          }
                    this.idleService.resetIdle();

          this.router.navigateByUrl("/");
        }
      })
  }
ngOnDestroy() {
    this.sub.unsubscribe();
  }


  onPopupClose(): void {
    this.display = false;
    this.hasToken=false
    // this.authService.clearToken();
    // localStorage.clear();
    this.logOut();
  }

}
